import { ChangeDetectionStrategy, Component, OnInit, input, output, inject } from '@angular/core';
import { Transaction, Action } from 'src/app/types';
import { TransactionDataSource } from '../transaction-data-source.class';
import { UI_DIALOG_DATA, UiDialogRef } from '../../ui/dialog/dialog.service';
import { UiDialogShellComponent } from '../../ui/dialog-shell/dialog-shell.component';
import { EditTransactionsComponent } from '../edit-transactions/edit-transactions.component';

interface EditTransactionListItemDialogData {
  transaction: Transaction;
  transactionDataSource: TransactionDataSource;
}

@Component({
  selector: 'edit-transaction-list-item',
  templateUrl: './edit-transaction-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex h-full min-h-0 w-full flex-col',
  },
  imports: [UiDialogShellComponent, EditTransactionsComponent],
})
export class EditTransactionListItemComponent implements OnInit {
  private dialogRef = inject<UiDialogRef<void> | null>(UiDialogRef, { optional: true });
  private dialogData = inject<EditTransactionListItemDialogData | null>(UI_DIALOG_DATA, { optional: true });

  readonly transaction = input<Transaction>();
  readonly transactionDataSource = input<TransactionDataSource>();
  readonly closeEditTransaction = output<void>();

  transactions: Transaction[] = [];
  private activeTransactionDataSource?: TransactionDataSource;

  constructor() {
    if (this.dialogData) {
      this.activeTransactionDataSource = this.dialogData.transactionDataSource;
      this.transactions = [this.dialogData.transaction];
    }
  }

  ngOnInit(): void {
    if (this.dialogData) return;

    this.activeTransactionDataSource = this.transactionDataSource();
    const transaction = this.transaction();
    this.transactions = transaction ? [transaction] : [];
  }

  transactionListEvent(action: Action) {
    if (action.type !== 'CANCEL') {
      if (!this.activeTransactionDataSource) {
        console.error('Unable to edit transaction: missing transaction data source.');
        return;
      }

      this.activeTransactionDataSource.dispatch(action);
    }

    this.close();
  }

  private close() {
    this.closeEditTransaction.emit();
    this.dialogRef?.close();
  }
}
